import React, {useState} from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import {Body, Button, Headline} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import Modal from '@/components/modal';
import styles from './BrandFeedbackMessageModal.module.scss';

type BrandFeedbackMessageModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (message: string) => void;
  title: string;
  description?: string;
  confirmLabel?: string;
  placeholder?: string;
  required?: boolean;
};

function BrandFeedbackMessageModal({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = translate('Send to Creator'),
  placeholder,
  required = false,
}: BrandFeedbackMessageModalProps) {
  const [message, setMessage] = useState('');

  const handleConfirm = () => {
    onConfirm(message);
    setMessage('');
  };

  const handleClose = () => {
    setMessage('');
    onClose();
  };

  const isConfirmDisabled = required && !message.trim();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      size="small"
      contentClassName={styles.modalContent}
    >
      <div className={styles.content}>
        <Headline size="md" className={styles.title}>
          {title}
        </Headline>
        {description ? (
          <Body size="md" className={styles.description}>
            {description}
          </Body>
        ) : null}
        <TextareaAutosize
          className={styles.textarea}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder={placeholder}
          minRows={5}
          maxRows={5}
        />
        <div className={styles.actions}>
          <Button
            appearance="neutral"
            mode="tinted"
            size="large"
            onClick={handleClose}
          >
            {translate('Cancel')}
          </Button>
          <Button
            appearance="neutral"
            mode="filled"
            size="large"
            onClick={handleConfirm}
            disabled={isConfirmDisabled}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default BrandFeedbackMessageModal;
